import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Flex, Text, Hr, SanitizedHTML } from 'core/ui/atoms';
import { Accordion } from 'core/ui/atoms/V2';
import VariantOutlineTab from 'dashboard/ui/components/ProductPage/ProductSpecs/VariantOutlineTab';

const NutritionSection = ({
  componentDetail,
  setSelectedVariant,
}) => {
  const { variants, variantId, nutrition, allergens, instructions } = componentDetail;

  const currentVariant = variants?.find((variant) => variant.id === variantId) || {};

  const ingredients = componentDetail?.ingredients || [];
  const ingredientsList = ingredients?.map((ingredient) => ({ label: ingredient.name }));

  const allergensList = allergens?.map((item) => ({ label: item }));

  return (
    <Box>
      <Title>Nutrition Per Serving</Title>
      { (variants || []).length > 1 &&
        <VariantOutlineTab
          selectedVariant={currentVariant}
          variants={variants}
          onChange={setSelectedVariant}
        />
      }
      <Flex direction='row' justifyContent='space-between'>
        <NutritionName>Serving Size</NutritionName>
        <NutritionValue>1 container</NutritionValue>
      </Flex>
      <Hr />
      <Flex direction='row' justifyContent='space-between'>
        <NutritionName>Calories</NutritionName>
        <NutritionValue>{Number(nutrition?.calories).toFixed(0)}kcal</NutritionValue>
      </Flex>
      <Hr />
      <NutritionTitle direction='row' justifyContent='space-between'>
        <NutritionName>Total Fat</NutritionName>
        <NutritionValue>{Number(nutrition?.fatGrams).toFixed(0)}g</NutritionValue>
      </NutritionTitle>
      <Flex direction='row' justifyContent='space-between'>
        <NutritionValue>Serving Size</NutritionValue>
        <NutritionValue>1 container(approx.13.9 oz)</NutritionValue>
      </Flex>
      <Hr />
      <NutritionTitle direction='row' justifyContent='space-between'>
        <NutritionName>Carbs</NutritionName>
        <NutritionValue>{Number(nutrition?.carbsGrams).toFixed(0)}g</NutritionValue>
      </NutritionTitle>
      <Flex direction='row' justifyContent='space-between'>
        <NutritionValue>Fiber</NutritionValue>
        <NutritionValue>{Number(nutrition?.fiberGrams).toFixed(0)}g</NutritionValue>
      </Flex>
      <Flex direction='row' justifyContent='space-between'>
        <NutritionValue>Sugar</NutritionValue>
        <NutritionValue>{Number(nutrition?.sugarGrams).toFixed(0)}g</NutritionValue>
      </Flex>
      <Flex direction='row' justifyContent='space-between'>
        <NutritionValue>Sugar Alcohol</NutritionValue>
        <NutritionValue>{Number(nutrition?.sugarAlcoholGrams).toFixed(0)}g</NutritionValue>
      </Flex>
      <Hr />
      <NutritionTitle direction='row' justifyContent='space-between'>
        <NutritionName>Protein</NutritionName>
        <NutritionValue>{Number(nutrition?.proteinGrams).toFixed(0)}g</NutritionValue>
      </NutritionTitle>
      <Hr />
      {ingredientsList && <ContainerHeader>
        <Accordion key="nav-programs"
          subMenus={ingredientsList}>
          Ingredients
        </Accordion>
      </ContainerHeader>}
      {allergensList && <ContainerHeader>
        <Accordion key="nav-programs"
          subMenus={allergensList}>
          Allergens
        </Accordion>
      </ContainerHeader>}
      {instructions && <ContainerHeader>
        <Accordion key="nav-programs"
          subMenus={[]}
          content={<SanitizedHTML rawHTML={instructions} />}>
          Cooking Instructions
        </Accordion>
      </ContainerHeader>}
    </Box>
  );
};

NutritionSection.propTypes = {
  componentDetail: PropTypes.object.isRequired,
  setSelectedVariant: PropTypes.func.isRequired,
};

const ContainerHeader = styled(Box)`
  margin-top: 20px;
`;

const Title = styled(Text)`
  color: ${(p) => p.theme.colors.primaryV2};
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;

const NutritionTitle = styled(Flex)`
  margin-bottom: 10px;
`;

const NutritionName = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0px;
`;

const NutritionValue = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0px;
`;

export default NutritionSection;
